<!-- 个人中心 > 个人信息 -->
<template>
  <div class="personInfo">
    <commonHeader :title="'个人信息'"></commonHeader>
    <span class="myEdit" @click="toEdit">
      <img style="vertical-align: top;margin-right: 10px" src="../../../assets/img/personalCenter/edit.png" alt="">
      编辑
    </span>
    <div class="personInfoMain">
      <el-form ref="personInfoForm" label-position="left" style="margin: 30px 10px 0px">
        <el-form-item label="头像 :" label-width="90px">
          <img :src="userData.headImg ? $winpowUrl + userData.headImg : defaultHeadImg" style="width: 80px;height: 80px" alt="">
        </el-form-item>
        <el-form-item label="账号 :" label-width="90px">
          <span class="detail">{{ userData.userAccount }}</span>
        </el-form-item>
        <el-form-item label="姓名 :" label-width="90px">
          <span class="detail">{{ userData.userName }}</span>
        </el-form-item>
        <el-form-item label="手机 :" label-width="90px">
          <span class="detail">{{ userData.userPhone }}</span>
        </el-form-item>
        <el-form-item label="地址 :" label-width="90px">
          <span class="detail">{{ userData.address }}</span>
        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>
import commonHeader from '../componets/CommonHeader'
import { mapState } from 'vuex'
export default {
  name: 'PersonInfo',
  components: { commonHeader },
  data () {
    return {
      defaultHeadImg: require('../../../assets/img/personalCenter/head.png')
    }
  },
  computed: {
    ...mapState(['userData'])
  },
  mounted () {
    setTimeout(() => {
      if (!this.userData.companyPkid) {
        this.$confirm('用户未关联企业，点击确认关联企业', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        }).then(() => {
          this.$bus.$emit('candleSSo', 8, 'window')
          //   window.open(this.$winpowUrl + '/usercenter/getQiyeinfo.html?qiye.t=v')
        }).catch(() => { })
      }
    }, 300)
  },
  created () {
    this.getUserInfo()
  },
  methods: {
    getUserInfo () {
      this.$post('/front/userCenter/userInfo').then(res => {
      })
    },
    toEdit () {
      this.$confirm('请前往盈创动力官网个人中心修改信息 !', '提示', {
        confirmButtonText: '前往',
        cancelButtonText: '取消'
      }).then(() => {
        window.open(this.$winpowUrl)
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.personInfo {
  position: relative;
  .myEdit {
    color: #1474de;
    position: absolute;
    top: 7px;
    left: 150px;
    cursor: pointer;
  }
  .myEdit:hover {
    color: #1466cf !important;
  }
  .personInfoMain {
    width: 100%;
    border-top: 2px solid #eaeaea;
    margin-top: 20px;
    .detail {
      font-size: 16px;
    }
  }
  .myButtons {
    display: inline-block;
    margin-left: 280px;
    margin-top: 30px;
    .myBtn {
      width: 70px;
      margin: 0 20px;
      height: 30px;
      border-radius: 4px;
      font-size: 16px;
    }
  }
}
</style>
